import React,{useState,useEffect} from 'react';

const ImageTileSkelton=({tileId})=>{
    return(
        <div>
            <div className={`blue-gr-box search grid grid-cols-1 alim-interactive-tile zamzam-tile w-full p-0`}>
                <div className="col-span-1 aspect-ratio-box rounded-md">
                    {/* thumbnail */}
                    <div className='w-[480px] h-[360px] h-full rounded-md bg-light-beige dark:bg-light-blue animate-glow block bg-light-blue'>
                        <img src="/images/zamzam/zamzam.webp"/>
                        <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer"></div>
                    </div>
                </div>
                <div className="col-span-1 flex flex-col justify-between p-3">
                        {/* info goes here */}
                        <div className="h-3 w-3/4 rounded bg-light-beige dark:bg-light-blue overflow-hidden relative mb-2">
                            <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer"></div>
                        </div>
                        <div className="h-3 w-1/2 rounded bg-light-beige dark:bg-light-blue overflow-hidden relative">
                            <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-light-blue dark:via-light-beige to-transparent animate-shimmer"></div>
                        </div>
                </div>
            </div>
        </div>
    )
}

export default ImageTileSkelton;